class Footer {

	constructor() {
		this.initialize();
	}

	initialize() {
		let scroll = 0;
		let wH = $(window).height();
		let up = $('[data-up]');
		let menuBtn = $('[data-menu-footer-btn]');

		$(window).on('scroll', function() {
			scroll = $(this).scrollTop();

			if (scroll > wH){
				up.addClass('show');
			} else {
				up.removeClass('show');
			}
		});

		menuBtn.on('click', function() {
			let el = $(this);
			let menu = el.next();
			let ww = $(window).width();

			if (ww < 768) {
				menu.slideToggle(300);
				el.toggleClass('open');
			} else {
				menu.removeAttr('style');
				el.removeClass('open');
			}
		});

		$(window).on('resize', function() {
			let ww = $(window).width();
			if (ww > 767) {
				menuBtn.removeClass('open');
				menuBtn.next().removeAttr('style');
			}
		});
	}
}

new Footer();
